
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import WebStorage from '@/common/WebStorage';
import { mapGetters, mapActions } from 'vuex';
import { restApi } from '@/components/mixins/restApi';
import { SERVERS_SMTP_MODAL_KEY } from '../constants';
import { showMessage } from '@/components/mixins/showMessage';

import Modal from './Modal.vue';
import InfoBox from '@/components/InfoBox.vue';
import ModalButtonCancel from '@/components/ModalButtonCancel.vue';
import AliareInput from '@/components/AliareInput.vue';
import ModalButtonSuccess from '@/components/ModalButtonSuccess.vue';
import InfoAliare from '@/components/InfoAliare.vue';

import AlertNotificationModal from '@/components/AlertNotificationModal.vue';
import { workflowPermission } from '@/components/mixins/permissions/workflow';
import { workflowHelpers } from '@/components/mixins/workflowHelpers';

export default mixins(
	restApi,
	showMessage,
	workflowHelpers,
	workflowPermission,
).extend({
	name: 'CreateEditSMTPServer',
	components: {
		Modal,
		InfoBox,
		ModalButtonCancel,
		AliareInput,
		ModalButtonSuccess,
		AlertNotificationModal,
		InfoAliare,
	},
	props: {
		dataModal: {
			type: Object,
		},
	},
	data() {
		return {
			currentStep: 'testServer',
			listAuth: [
				{
					name: 'BasicAuth',
					label: 'Básica',	
				},
				{
					name: 'OAuth2',
					label: 'Oauth02',	
				},
			],
			criptoAuth: [
				{
					name: 'Sem Criptografia',
					label: null,
				},
				{
					name: 'SSL',
					label: 'SslOnConnect',	
				},
				{
					name: 'TLS',
					label: 'StartTls',	
				},
			],
			listServer: [
				{
					name: 'Google',
					label: 'Google',	
				},
				{
					name: 'Microsoft',
					label: 'Microsoft',	
				},
			],
			validation: false,
			isLoading: false,
			showAlert: {
				mode: '',
				active: false,
			},
			modalBus: new Vue(),
			SERVERS_SMTP_MODAL_KEY,
			prevForm: {
				id: '',
				tenantId: '',
				serverName: '',
				clientSecret: '',
				clientId: '',
                email: '',
                password: '',
				port: '',
				host: '',
				auth: '',
				code: '',
				criptografia: null,
				authServer: '',
            },
			form: {
				id: '',
				tenantId: '',
				serverName: '',
				clientSecret: '',
				clientId: '',
                email: '',
                password: '',
				port: '',
				host: '',
				auth: '',
				code: '',
				criptografia: null,
				authServer: '',
            },
		};
	},
	async created() {
		this.isLoading = true;

		this.isLoading = false;
	},
	computed: {
		isEdit() {
			if (!!this.dataModal?.serverId) {
				return true;
			}

			return false;
		},
		textInfoAuth() {
			const stringText = `<strong>Autenticação via OAuth2!</strong><br>
				<p>O cadastro será apenas por <b>Permissão Delegada</b>, após concluir o cadastro
				será necessário realizar login no servidor de email escolhido.</p>`
				
			return stringText;	
		},
		canFinishConfig(): boolean {
			if (!this.form.serverName || !this.form.email) return false;

			if (this.form.auth === 'BasicAuth') {
				return (
					!!this.form.host &&
					!!this.form.port &&
					!!this.form.password
				);
			}

			if (this.form.auth === 'OAuth2') {
				const isMicrosoft =
					this.form.authServer === 'Microsoft' && !!this.form.tenantId;
				const isGoogle = this.form.authServer === 'Google';

				return (
				(isMicrosoft || isGoogle) &&
				!!this.form.clientId &&
				!!this.form.clientSecret
				);
			}

			return false;
		},
		infoText() {
			return 'Para autenticação via OAuth2,<br> utilize neste campo o mesmo <br> e-mail que será usado no login,<br> pois será aplicada permissão<br> delegada.'
		},
		googleAuth() {
			return this.form.authServer == 'Google' && this.form.auth == 'OAuth2';
		},
		microsoftAuth() {
			return this.form.authServer == 'Microsoft' && this.form.auth == 'OAuth2';
		},
		varHeight() {
			if (this.form.auth) {
				return '800px';
			} else {
				return '600px';
			}
		},
		testServerInfo() {
			return `O cadastro do servidor foi feito com sucesso, para completarmos a configuração precisamos que seja realizado um teste de envio de email, clique no botão abaixo`
		},
		dynamicTextInfo() {
			return `<b>Limite de e-mails diários!</b><br><p>O envio de e-mails está sujeito a limites diários, os quais são definidos pelos servidores de e-mail terceiros que serão utilizados. Esses limites podem variar conforme o provedor e as configurações de cada servidor.</p>`;
        },
		keepText() {
			if (this.showAlert.mode == 'resetFailWorkflow') {
				return 'Manter Fluxo de Falha';
			} else if (this.showAlert.mode == 'cancelConfigSettings') {
				return 'Manter parametrização'
			}
		},

		cancelText() {
			if (this.showAlert.mode == 'resetFailWorkflow') {
				return this.$locale.baseText('workflowDetails.patchFlowFail.removeFailureFlow');
			} else if (this.showAlert.mode == 'cancelConfigSettings') {
				return 'Cancelar parametrização'
			}
		},

		titleAlertModal() {
			if (this.showAlert.mode == 'resetFailWorkflow') {
				return this.$locale.baseText('workflowDetails.patchFlowFail.removeFailureFlow');
			} else if (this.showAlert.mode == 'cancelConfigSettings') {
				return 'Cancelar Parametrização'
			}
		},
		alertNotificationDescription() {
			if (this.showAlert.mode == 'resetFailWorkflow') {
				return this.$locale.baseText(`Ao parar de usar o <b>Fluxo de Falha</b>, caso a execução do fluxo que você está criando resulte em <b>Falha</b>, não haverá o acionamento de um <b>Fluxo de Falha</b>. O que deseja fazer?`);
			} else if (this.showAlert.mode == 'cancelConfigSettings') {
				return 'Todas as parametrizações que estão sendo feitas serão excluídas e você não poderá recuperá-las. O que você deseja fazer?'
			}
		},
		pageTitleMode() {
			return 'Configuração de E-mail Personalizado';
		},
		saveTitleMode() {
			if (this.mode === 'changeFailure') {
				return 'Salvar Alterações';
			} else {
				return 'Concluir';
			}
		},
	},
	
	methods: {
		...mapActions('workflows', ['getWorkflowsFails', 'patchWorkflowFail', 'getWorkflows']),
		...mapActions('aliareAccount', ['createConfigServerSMTP', 'sendTestEmailSMTP', 'deleteEmailServerById', 'getServerById', 'editConfigServerSMTP']),

		async testConnection(idServer: string): Promise<boolean> {
			try {
				await this.sendTestEmailSMTP(idServer);

				this.$store.commit('activeAlert', {
					message: 'Os dados do provedor de e-mail foram salvos e validados com sucesso. A integração está pronta para ser utilizada.',
					status: 'success',
				});

				return true;
			} catch (e) {
				if (this.isEdit) {
				const payload = {
					id: this.prevForm.id,
					name: this.prevForm.serverName,
					tenantId: WebStorage.getItem('tenantId'),
					email: this.prevForm.email,
					authenticationType: this.prevForm.auth,
					authenticationParameters: {
					host: this.prevForm.host,
					port: Number(this.prevForm.port),
					password: this.prevForm.password,
					smtpEncryptionType: this.prevForm.criptografia == null ? 'None' : this.prevForm.criptografia,
					clientId: this.prevForm.clientId,
					secretId: this.prevForm.clientSecret,
					tenantId: this.prevForm.tenantId,
					authorizationCode: this.prevForm.code,
					redirectUri: window.location.origin + '/auth/oauth/callback',
					},
					products: ['aca76e07-280f-4e1f-a4df-f8a94757e0fc'],
				};
				await this.editConfigServerSMTP(payload);

				this.$store.commit('activeAlert', {
					message: 'Os dados do provedor de e-mail não foram salvos devido a uma falha no teste de envio de email. Tente novamente.',
					status: 'error',
				});
				} else {
				await this.deleteEmailServerById(idServer);

				this.$store.commit('activeAlert', {
					message: 'Os dados do provedor de e-mail não foram salvos devido a uma falha no teste de envio de email. Tente novamente.',
					status: 'error',
				});
				}

				this.isLoading = false;
				return false;
			}
		},


		async finishAuthConfig(testConnection: boolean) {
			this.isLoading = true;
			
			if (!this.isEdit) {
				if (this.form.auth == 'OAuth2') {
					this.authUrlPopup(testConnection);
				} else {
					this.createServerSMTP(testConnection);
				}
			} else {
				const payload = this.generatePayload();
				this.prevForm.password = payload.authenticationParameters.password;
				this.prevForm.clientSecret = payload.authenticationParameters.secretId;
				await this.editConfigServerSMTP(payload).then(async (response) => {
					if (testConnection) {
						await this.testConnection(response.id);
					} else {
						this.$store.commit('activeAlert', {
							message: 'Servidor de email atualizado com sucesso!',
							status: 'success',
						});

						this.modalBus.$emit('close');
					}
				}).catch((e) => {
					this.$store.commit('activeAlert', {
						message: e.notifications[0] || 'Ocorreu um erro ao tentar salvar os dados do servidor, tente novamente.',
						status: 'error',
					});
					this.isLoading = false;
				})
			}
		},
		generatePayload() {
			const payload = {
				active: true,
				id: this.form.id,
				name: this.form.serverName,
				tenantId: WebStorage.getItem('tenantId'),
				email: this.form.email,
				oAuth2Server: this.form.authServer,
				authenticationType: this.form.auth,
				authenticationParameters: {
					host: this.form.host,
					port: Number(this.form.port),
					password: this.form.password,
					smtpEncryptionType: this.form.criptografia == null ? 'None' : this.form.criptografia,
					clientId: this.form.clientId,
					secretId: this.form.clientSecret,
					tenantId: this.form.tenantId,
					authorizationCode: this.form.code,
					redirectUri: window.location.origin + '/auth/oauth/callback',
				},
				products: ['aca76e07-280f-4e1f-a4df-f8a94757e0fc'],
			}
			return payload;
		},
		async createServerSMTP(testConnection) {
			const payload = this.generatePayload();
			
			await this.createConfigServerSMTP(payload).then(async (response) => {
				if (testConnection) {
					const success = await this.testConnection(response.id);
					if (success) {
						this.$root.$emit('addCreatedSMTP', response);

						this.modalBus.$emit('close');
					}
				} else {
					this.$store.commit('activeAlert', {
						message: 'Servidor de email criado com sucesso!',
						status: 'success',
					});

					this.$root.$emit('addCreatedSMTP', response);

					this.modalBus.$emit('close');
				}
			}).catch((e) => {
				this.$store.commit('activeAlert', {
					message: e.notifications[0] || 'Ocorreu um erro ao tentar salvar os dados do servidor, tente novamente.',
					status: 'error',
				});
				this.isLoading = false;
			})
		},
		async authUrlPopup(testConnection) {
			const vm = this;
			const width = 600;
			const height = 600;
			const left = (window.innerWidth / 2) + window.screenX - (width / 2);
			const top = (window.innerHeight / 2) + window.screenY - (height / 2);
			let authUrl = '';

			if (this.googleAuth) {
				authUrl = `https://accounts.google.com/o/oauth2/auth?login_hint=${this.form.email}&response_type=code&client_id=${this.form.clientId}&redirect_uri=${window.location.origin}/auth/oauth/callback&scope=email https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/userinfo.email openid&access_type=offline&prompt=consent`;
			} else if (this.microsoftAuth) {
				authUrl = `https://login.microsoftonline.com/${this.form.tenantId}/oauth2/v2.0/authorize?login_hint=${this.form.email}&response_type=code&client_id=${this.form.clientId}&redirect_uri=${window.location.origin}/auth/oauth/callback&scope=.default offline_access`;
			}

			try {

				const popup = window.open(authUrl, '_blank', `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`);


				function handleMessage(event) {
					if (event.origin !== window.location.origin) {
						console.error('Origem não permitida:', event.origin);
						return;
					}

					const { code } = event.data;
					if (code) {
						vm.form.code = code;
						popup.close();
						
						vm.createServerSMTP(testConnection);

						vm.modalBus.$emit('close');

						window.removeEventListener('message', handleMessage);
					}
				}
				window.addEventListener('message', handleMessage);


			} catch (error) {
				console.error('Erro ao acessar o Auth URL:', error);
				throw error;
			}
		},

		closeDialog() {
			this.modalBus.$emit('close');
		},

		openAlertModal(data: {mode: string, active: boolean}) {
			this.showAlert.active = data.active;
			this.showAlert.mode = data.mode;
		},
		async loadCurrentServer() {
			this.isLoading = true;
			try {
				const response = await this.getServerById(this.dataModal.serverId);
				this.form.tenantId = response.tenant.id;
				this.form.serverName = response.name;
				this.form.clientId = response.authenticationParameters.clientId,
				this.form.email = response.email;
				this.form.port = String(response.authenticationParameters.port);;
				this.form.host = response.authenticationParameters.host;
				this.form.auth = response.authenticationType;
				this.form.criptografia = response.authenticationType.smtpEncryptionType == 'None' ? null : response.authenticationType.smtpEncryptionType;
				this.form.authServer = response.oAuth2Server;
				this.form.id = response.id;

				this.prevForm = JSON.parse(JSON.stringify(this.form));


			} catch(e) {
				this.$store.commit('activeAlert', {
					message: 'Não foi possível carregar os dados da notificação, tente novamente!',
					status: 'error',
				});
				this.modalBus.$emit('close');
			}

			this.isLoading = false;

		},


	},

	async mounted() {
		if (this.isEdit) {
			this.loadCurrentServer();
		}
	}
});
